import React from 'react'
import { connect } from 'react-redux'
import { withRouteData } from 'react-static'

import ModelCards from './ModelCards'
import StickyBar from './StickyBar'

const SearchResultsGroup = ({
    title,
    intentSlugs,
    allIntents,
    catalogSearch,
    contentType,
}) => {
    if (
        catalogSearch.contentType &&
        catalogSearch.contentType.value !== contentType
    ) {
        return null
    }

    let filteredIntents = intentSlugs.map(
        slug => allIntents[['ai', contentType, slug].join('/')]
    )

    if (catalogSearch.integratedOnly) {
        filteredIntents = filteredIntents.filter(intent => intent.hasIntegrated)
    }
    if (catalogSearch.search) {
        const test = catalogSearch.search.toLowerCase()
        const ok = line => line.toLowerCase().indexOf(test) !== -1

        filteredIntents = filteredIntents.filter(intent => {
            if (ok(intent.title)) {
                return true
            }
            if (ok(intent.url)) {
                return true
            }
            if (ok(intent.description)) {
                return true
            }
            const providerNames = intent.providers.map(p => p.title).join(' ')
            if (ok(providerNames)) {
                return true
            }
            return false
        })
    }

    if (filteredIntents.length < 1) {
        return null
    }

    return (
        <div className="search-results__group">
            <StickyBar title={title} />
            <h2 className="search-results__title h2">{title}</h2>
            <div className="search-results__list">
                <div className="model-cards">
                    <ModelCards intents={filteredIntents} />
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        catalogSearch: state.catalogSearch || {},
    }
}

export default connect(mapStateToProps)(withRouteData(SearchResultsGroup))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/SearchResultsGroup.jsx